
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/learn/lessons",
      function () {
        return require("private-next-pages/learn/lessons/index.tsx");
      }
    ]);
  